import { ArrowRight, CircleDot, type LucideIcon, Sparkles } from "lucide-react";

import type { AgendaItem } from "@elation/api-client/src/stitch-web";

import {
  AgendaItemEntity,
  type AgendaItemProgressState,
} from "@src/features/agenda/domain";
import { Badge } from "@src/shared/components/ui/badge";
import { cn } from "@src/shared/lib/utils";

const PROGRESS_BADGE_CLASSES: Partial<Record<AgendaItemProgressState, string>> =
  {
    discussed: "bg-muted text-muted-foreground hover:bg-muted",
    assessed: "bg-muted text-muted-foreground hover:bg-muted",
    follow_up: "bg-accent/10 text-accent hover:bg-accent/10",
    completed_by_ai: "bg-accent/15 text-accent hover:bg-accent/15",
  };

const PROGRESS_BADGE_ICONS: Partial<
  Record<AgendaItemProgressState, LucideIcon>
> = {
  discussed: CircleDot,
  assessed: CircleDot,
  follow_up: ArrowRight,
  completed_by_ai: Sparkles,
};

export function AgendaProgressBadge({ item }: { item: AgendaItem }) {
  const progressState = AgendaItemEntity.progressState(item);
  const label = AgendaItemEntity.progressBadgeLabel(item);
  const Icon = PROGRESS_BADGE_ICONS[progressState];

  if (label == null || Icon == null) return null;

  return (
    <Badge
      className={cn(
        "shrink-0 gap-1 rounded-full border-transparent px-1.5 py-0 text-[10px] font-semibold",
        PROGRESS_BADGE_CLASSES[progressState],
      )}
      variant="secondary"
    >
      <Icon aria-hidden="true" className="size-2.5" />
      {label}
    </Badge>
  );
}
